<template>
  <div class="e-table" ref="lTable">
    <!-- @row-click="handleTableRow" -->
    <div class="table-header">
      <slot name="query"></slot>
    </div>
    <el-table
      :data="tableData"
      :max-height="tableHeight"
      :row-key="rowKey"
      :expand-row-keys="expandRowKeys"
      :row-style="rowStyle"
      :border="border"
      :row-class-name="rowBg"
      :summary-method="summaryMethod"
      :show-summary="showSummary"
      :highlight-current-row="highlightCurrentRow"
      @selection-change="mirChange"
      @cell-click="handleTableCell"
    >
      <template v-for="(item, i) in tableHeader">
        <el-table-column
          :key="i + 'a'"
          type="selection"
          :selectable="item.selectable || null"
          :width="item.width || ''"
          align="center"
          v-if="item.label == 'selection'"
        ></el-table-column>
        <el-table-column
          :key="i + 'b'"
          type="index"
          :index="indexMethod"
          :label="'序号'"
          :width="item.width || ''"
          align="center"
          v-else-if="item.label == '序号' || item.label == 'ID'"
        ></el-table-column>
        <el-table-column
          :type="item.label == 'expand' ? 'expand' : ''"
          :key="i + 'c'"
          :prop="item.prop"
          :label="item.label == 'expand' ? '' : item.label"
          :align="item.align || 'left'"
          :width="item.width || ''"
          :min-width="item.minWidth || ''"
          :fixed="item.fixed || false"
          :sortable="item.sortable || false"
          :show-overflow-tooltip="item.render ? false : item.overflowTooltip === false ? false : true"
          v-else
        >
          <template slot-scope="scope">
            <slot :name="item.prop" :row="scope.row" v-if="item.render"></slot>
            <el-tooltip class="item" effect="dark" :content="scope.row[item.prop]" placement="top" v-else-if="item.tooltip">
              <div class="toltip-content" :style="{ width: item.width + 'px' }">{{ scope.row[item.prop] }}</div>
            </el-tooltip>
            <span v-else>{{ scope.row[item.prop] }}</span>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <Pagination :total="total" :page.sync="tableQuery.pageNum" :limit.sync="tableQuery.pageSize" :pageSizes="pageSelectSizes" @pagination="childMethod" v-if="isPagination" />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination/pagination';
export default {
  name: 'ETable',
  components: {
    Pagination,
  },
  computed: {},
  props: {
    tableLoading: {
      type: Boolean,
      default: false,
    },
    isPagination: {
      type: Boolean,
      default: true,
    },
    total: {
      type: Number,
      default: 0,
    },
    tableHeight: {
      type: String,
      default: '$index',
    },
    tableQuery: {
      type: Object,
      default: () => ({
        pageNum: 1,
        pageSize: 5,
      }),
    },
    tableHeader: {
      type: Array,
      default: () => [],
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    getTableList: {
      type: Function,
      default: null,
    },
    select_table_data: {
      type: Array,
      default: () => [],
    },
    rowStyle: {
      type: Function,
      default: null,
    },
    rowKey: {
      type: String,
      default: '950px',
    },
    expandRowKeys: {
      type: Array,
      default: () => [],
    },
    tooltip: {
      type: Boolean,
      default: false,
    },
    border: {
      type: Boolean,
      default: true,
    },
    pageSelectSizes: {
      type: Array,
      default() {
        return [5, 10, 15];
      },
    },
    showSummary: {
      type: Boolean,
      default: false,
    },
    summaryMethod: {
      type: Function,
      default: null,
    },
    highlightCurrentRow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // tableHeight: '950px',
    };
  },
  created() {},
  mounted() {},
  decreated() {},
  watch: {},

  methods: {
    //计算序号
    indexMethod(index) {
      if (this.isPagination) {
        return index + 1 + (this.tableQuery.pageNum - 1) * this.tableQuery.pageSize;
      } else {
        return index + 1;
      }
    },
    //计算表格高度
    calculateHeight() {
      // this.$nextTick(() => {
      //   let searchFormHeihgt = 0;
      //   if (this.$parent.$refs.serachForm) {
      //     searchFormHeihgt = this.$parent.$refs.serachForm.clientHeight || 0;
      //   }
      //   this.tableHeight = 'height: calc(100vh - 150px - ' + searchFormHeihgt + 'px)';
      // });
    },
    childMethod() {
      this.getTableList();
    },
    mirChange(selection) {
      this.$emit('update:select_table_data', selection);
    },
    handleTableCell(row, column, cell, event) {
      this.$emit('handleCell', row, column, event);
    },
    rowBg({ row, rowIndex }) {
      const inx = sessionStorage.getItem('tableIndex') || '';
      let index = rowIndex + (this.tableQuery.pageNum - 1) * this.tableQuery.pageSize;
      if (this.isPagination) {
        row.inx = index;
      } else {
        row.inx = rowIndex;
      }
      if (inx == index && inx !== '') {
        return 'success-row';
      } else {
        return '';
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.e-table {
  .serach-form {
    padding: 32px 16px 0 16px;
    box-sizing: border-box;
    .search-reset {
      border: 1px solid #1890ff;
      color: #1890ff;
    }
    .more-container {
      .more-text {
        margin-left: 5px;
        vertical-align: middle;
        font-size: 14px;
        color: #1890ff;
      }
      .rotate-more-img {
        width: 10px;
        height: 10px;
        vertical-align: middle;
        transform: rotate(180deg);
        transition: all 300ms;
      }
      .reverse-more-img {
        width: 10px;
        height: 10px;
        vertical-align: middle;
        transform: rotate(0deg);
        transition: all 300ms;
      }
      &:hover {
        cursor: pointer;
      }
    }
  }
  ::v-deep {
    .el-table td,
    .el-table th.is-leaf,
    .el-table--border,
    .el-table--group {
      border-color: #d9d9d9;
    }
    .el-table--border::after,
    .el-table--group::after,
    .el-table::before,
    .el-table__fixed-right::before {
      background-color: #d9d9d9;
    }
    .el-table--border .el-table__cell:first-child .cell {
      padding: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ETable/ETable.vue